import styled from '@emotion/styled';
import Table from 'app/components/Table';

export const StyledTable = styled(Table)`
  margin-top: 16px;
  thead {
    background: rgba(235, 241, 255, 1);

    th {
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      letter-spacing: 0.005em;
      text-align: left;

      &:before {
        display: none;
      }
    }
  }
  .ant-table-empty {
    .ant-table-cell {
      border-bottom: 0;
    }
  }
`;

export const StyledTotalLabel = styled.p`
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.005em;
  text-align: left;
  color: #8991a0;
`;
